import { useMemo } from 'react';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { getActiveSchedule } from 'shared/utils/get-active-schedule';

export const useActiveSchedule = (
  schedules: HabitSchedule[] | undefined | null,
) => useMemo(() => getActiveSchedule(schedules), [schedules]);
